/*jshint globalstrict: false*/

import Vue from 'vue';
import CoffeeCardListShellHome from '../components/home/coffee-card-list-shell-home';
import axios from 'axios';

Vue.component('coffee-card-list-shell-home', CoffeeCardListShellHome);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="coffee-list-home-vue"]',
    });
});
